export default __webpack_public_path__ + "static/media/Avatar-17.90f64b5c.svg";